export default __webpack_public_path__ + "static/DuctedVent-19963d4072471d79cb4e7eda9cc6bb42.jpg";